import React from "react";
import Slider from "react-slick";
import Image1 from "../../../assets/team/1.png";
import Image2 from "../../../assets/team/2.png";
import Image3 from "../../../assets/team/3.png";
import Image4 from "../../../assets/team/4.png";
import Image5 from "../../../assets/team/5.png";

const Team = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 4,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 4,
        },
      },
    ],
  };

  const teamdata = [
    {
      image: Image1,
      name: "steve  andrews",
      role: "Chief Analyst",
    },
    {
      image: Image2,
      name: "steve  andrews",
      role: "Chief Analyst",
    },
    {
      image: Image3,
      name: "steve  andrews",
      role: "Chief Analyst",
    },
    {
      image: Image4,
      name: "steve  andrews",
      role: "Chief Analyst",
    },
    {
      image: Image5,
      name: "steve  andrews",
      role: "Chief Analyst",
    },
  ];
  return (
    <section className="py-20">
      <div className="container ">
        <h1 className="text-[30px] md:text-[44px]  font-semibold ">
          Meet the<span className="text-primary font-semibold mb-4"> D3 </span>
          Team
        </h1>
        <p className="text-gray text-base md:text-lg  max-w-xl mb-4">
          Follow for more Updates
        </p>
        <Slider {...settings}>
          {[...teamdata, ...teamdata].map((val, i) => (
            <div className="p-4" key={i}>
              <div className=" border border-[#262626] rounded-xl p-4">
                <div>
                  <img src={val.image} alt="" className="w-full" />
                </div>
                <div className=" text-center pt-4 capitalize">
                  <p>{val.name}</p>
                  <p className="text-gray text-sm">{val.role}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Team;
